import { MutableRefObject } from "react";
import { getRenderingEngine } from "@cornerstonejs/core";

export const setupClippingPlane = (
  clippingPlaneRef: MutableRefObject<any>,
  volumeActorRef: MutableRefObject<any>
) => {
  if (!volumeActorRef.current || !clippingPlaneRef.current) return;

  // Initialize clipping plane after the volume is loaded
  setTimeout(() => {
    updateClippingPlane(clippingPlaneRef, volumeActorRef);
  }, 1000);
};

export const updateClippingPlane = (
  clippingPlaneRef: MutableRefObject<any>,
  volumeActorRef: MutableRefObject<any>,
  clipPlanePosition: number = 0.5
) => {
  if (!volumeActorRef.current || !clippingPlaneRef.current) return;

  const renderingEngine = getRenderingEngine("myRenderingEngine");
  if (!renderingEngine) return;

  const viewport = renderingEngine.getViewport("CT_3D_VOLUME");
  if (!viewport) return;

  // Get the bounds of the volume actor
  const bounds = volumeActorRef.current.getBounds();

  // Calculate the z-position based on the clipPlanePosition
  const zMin = bounds[4];
  const zMax = bounds[5];
  const zRange = zMax - zMin;
  const zPosition = zMin + zRange * clipPlanePosition;

  // Update the clipping plane's origin with the new z-position
  clippingPlaneRef.current.setOrigin(0, 0, zPosition);

  // Normal pointing down for axial cut (0,0,-1) will show top half
  clippingPlaneRef.current.setNormal(0, 0, -1);

  // Update the mapper's clipping plane
  const mapper = volumeActorRef.current.getMapper();

  // Enable clipping
  mapper.setClippingPlanes([clippingPlaneRef.current]);

  // Render the scene
  viewport.render();
};
